import { Component } from '@angular/core';
import { LoadScriptService } from './core/services/loadScript.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'AdminBiblicalTeachings';

  constructor(private loadScript: LoadScriptService) {
    this.loadScript.load(["table"]);
  }
}
